<template>
  <h1>hola</h1>
</template>

<script>
export default {
  name: "FiveDays",
};
</script>

<style></style>
